import '@mdi/font/css/materialdesignicons.css'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import 'vuetify/styles'
import '@/styles/theme.css'

import { createVuetify } from 'vuetify'
import { es } from 'vuetify/locale'

// Colors are the tokens of the "Quote App" design system (claude.ai/design).
// Custom colors are available as `color="primary-tint"`, `bg-line`, `text-ink-muted`, etc.
export default createVuetify({
  // Spanish texts for Vuetify's own components (table footers, pagination, sort labels).
  locale: {
    locale: 'es',
    messages: { es: { ...es, dataFooter: { ...es.dataFooter, itemsPerPageText: 'Filas por página:' } } },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#f7f5f1', // surface
          surface: '#ffffff', // surface-raised
          'on-background': '#1f2328', // ink
          'on-surface': '#1f2328', // ink
          primary: '#1f5f5b',
          'on-primary': '#ffffff',
          error: '#b3261e', // danger
          'on-error': '#ffffff',
          'primary-tint': '#e3eeec',
          'on-primary-tint': '#1f5f5b',
          'danger-tint': '#fbeae8',
          'on-danger-tint': '#b3261e',
          accent: '#b7791f',
          'ink-muted': '#5c6166',
          line: '#e4dfd6',
          'line-strong': '#8a857d',
          'chart-rest': '#6a9a96', // lighter `primary`: chart columns that aren't the one in focus (3:1 on white)
        },
        variables: {
          // Borders of cards and dividers use the `line` token at full strength.
          'border-color': '#e4dfd6',
          'border-opacity': 1,
          // Text is `ink` at full strength; medium emphasis on white lands on `ink-muted` (~6:1).
          'high-emphasis-opacity': 1,
          'medium-emphasis-opacity': 0.72,
        },
      },
    },
  },
  defaults: {
    VAlert: { rounded: 'lg', variant: 'flat' },
    VBtn: { rounded: 'lg', variant: 'flat' },
    VCard: { flat: true, border: true },
    VTextField: { variant: 'outlined', density: 'comfortable', color: 'primary', hideDetails: true },
    VAutocomplete: { variant: 'outlined', density: 'comfortable', color: 'primary', hideDetails: true },
    VTextarea: { variant: 'outlined', density: 'comfortable', color: 'primary', hideDetails: true },
  },
})
